import { useQuery } from '@tanstack/react-query';

import { valuePropsApi } from 'api/catalog/valueProps';

export const VALUE_PROPS_QUERY_KEY = 'catalogValueProps';

/**
 * @param {Array<{ id: number, code: string, displayName: string }>} valueProps
 * @returns {Array<{ text: string, value: number }>}
 */
export function mapValuePropsToSelectOptions(valueProps) {
    return valueProps.map((item) => ({ text: item.displayName, value: item.id }));
}

async function fetchValueProps({ signal }) {
    const response = await valuePropsApi.getValueProps({ signal });
    if (!response?.status) {
        throw new Error(response?.msg ?? 'Failed to fetch value props');
    }
    return response?.data?.valueProps ?? [];
}

/**
 * Fetches all catalog value props.
 */
export function useValuePropOptionsQuery({ enabled = true } = {}) {
    return useQuery({
        queryKey: [VALUE_PROPS_QUERY_KEY],
        enabled,
        queryFn: ({ signal }) => fetchValueProps({ signal }),
        staleTime: 15 * 60_000,
        gcTime: 30 * 60_000,
    });
}
